<script>
import { nextTick } from 'vue'

import Table from './common/SortedTable.vue'

import apiAnalyzes from '@/api/api-analyses'

export default {
    name: 'PricelistComponent',
    
    components: {
        Table
    },

    props: {
        languageStrings: {
            type: Object,
            default: null
        }
    },

    emits: ['form-closed'],

    computed: {
        headers() {
            let h = [
                {
                    id: 'name',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.pricelist009 != null ? this.languageStrings.ui.pricelist009 : 'Název'),
                    sort: true
                },
                {
                    id: 'frequent-order',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.pricelist006 != null ? this.languageStrings.ui.pricelist006 : 'Častá objednávka'),
                    sort: true
                },
                {
                    id: 'price-als',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.pricelist007 != null ? this.languageStrings.ui.pricelist007 : 'Cena ALS [Kč]'),
                    sort: true
                },
                {
                    id: 'price-kleentek',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.pricelist008 != null ? this.languageStrings.ui.pricelist008 : 'Cena KLEENTEK [Kč]'),
                    sort: true
                }
            ]

            return h
        },
        rows() {
            let r = []

            for (let i = 0; i < this.prices.length; i++) {
                r.push({
                    id: this.prices[i].analysis.id,
                    selected: false,
                    cells: [
                        {
                            id: 'name',
                            contenttype: 'text',
                            content: this.getAnalyzeName(this.prices[i].analysis.internalKey)
                        },
                        {
                            id: 'frequent-order',
                            contenttype: 'text',
                            content: (
                                this.prices[i].analysis.frequentOrder != null 
                                ? this.prices[i].analysis.frequentOrder 
                                    ? (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.form003 != null ? this.languageStrings.ui.form003 : 'Ano')
                                    : (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.form004 != null ? this.languageStrings.ui.form004 : 'Ne')
                                : (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.form004 != null ? this.languageStrings.ui.form004 : 'Ne')
                            )
                        },
                        {
                            id: 'price-als',
                            contenttype: 'text',
                            content: (this.prices[i].alsPrice != null ? this.prices[i].alsPrice.toString() : '')
                        },
                        {
                            id: 'price-kleentek',
                            contenttype: 'text',
                            content: (this.prices[i].kleentekPrice != null ? this.prices[i].kleentekPrice.toString() : '')
                        },
                    ]
                })
            }

            return r
        }
    },

    data() {
        return {
            analyzeType: "1",
            prices: []
        }
    },
    
    watch: {
        analyzeType: function() {
            this.getPrices()
        }
    },

    async mounted() {
        this.getPrices()

        await nextTick()
        document.getElementById('form').focus()
    },

    methods: {
        handleFormKeyDown(event) {
            if (event.key === 'Escape') {
                this.closeForm()
            }
        },
        closeForm() {
            this.$emit('form-closed')
        },
        async getPrices() {
            let result = await apiAnalyzes.getPriceByType(this.analyzeType)
            if (result.code === 0) {
                this.prices = result.data
            }
        },
        getAnalyzeName(internalKey) {
            if (this.languageStrings == null || this.languageStrings.analyses == null) {
                return internalKey
            }

            if (this.languageStrings.analyses[`${internalKey}_pointer`] != null && this.languageStrings.analyses[`${internalKey}_pointer`].length > 0)
                return this.languageStrings.analyses[`${internalKey}_pointer`]
            else
                return internalKey
        }
    }
}
</script>

<template>
    <div class="form">
        <div id="form" @keydown="handleFormKeyDown" tabindex="-1">
            <span class="title">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.menu013 != null ? languageStrings.ui.menu013 : 'Ceník' }}</span>
            <img src="@/assets/images/x.svg" @click="closeForm()" />

            <div class="form-wrapper">
                <div class="form-content rows gap-10">
                    <div>
                        <span>{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.pricelist001 != null ? languageStrings.ui.pricelist001 : 'Typ analýzy' }}</span>
                        <select v-model="analyzeType" style="display: inline-block; margin-left: 5px;">
                            <option value="1">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.pricelist002 != null ? languageStrings.ui.pricelist002 : 'Maziva' }}</option>
                            <option value="2">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.pricelist003 != null ? languageStrings.ui.pricelist003 : 'Paliva' }}</option>
                            <option value="3">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.pricelist004 != null ? languageStrings.ui.pricelist004 : 'Elektroizolační oleje' }}</option>
                            <option value="4">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.pricelist005 != null ? languageStrings.ui.pricelist005 : 'Emulze' }}</option>
                        </select>
                    </div>
                    
                    <div class="scrollable">
                        <Table v-if="prices.length > 0" :headers="headers" :rows="rows" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>